import { Folder, TextSnippet } from "@mui/icons-material";
import { ListItem, Box, Typography, Alert, Snackbar } from "@mui/material";
import { Stack } from "@mui/system";
import { get } from 'aws-amplify/api';

import * as React from "react";


export default function FileBrowser (
  props: {
    open: boolean,
    paths: any[]|null
    setSelectedItem: (selectedItem: any) => void
}) {
  const [selections, setSelections] = React.useState<string[]>([]);
  const [paths, setPaths] = React.useState<any[]>([]);
  const [openSnack, setOpenSnack] = React.useState(false);

  React.useEffect(() => {
    setPaths([]);

    if (!props.open) {
      return;
    }

    if (props.paths) {
      setPaths(props.paths);
    } else {
      const getOperation = get(
        {
          apiName: 'cabb',
          path: '/list',
        }
      );

      getOperation.response
        .then(response => response.body.json())
        .then((response: any) => {
          setPaths(response as any[]);
        })
        .catch((err: any) => {
          setOpenSnack(true);
        });
    }
  }, [props.open, props.paths]);

  const handleSelection = (path: string[], selection: any) => {
    // need to retrieve directory content if top level directory
    if (path.length === 0) {
      const getOperation = get(
        {
          apiName: 'cabb',
          path: '/list',
          options: {
            queryParams: {
              directory: selection['name'] + '/'
            }
          }
        }
      );

      getOperation.response
        .then(response => response.body.json())
        .then((response: any) => {
          const content = response as any[];
          if (content.length === 0) {
            return;
          }

          const newPaths = [...paths];

          const matches = newPaths.filter((p: any) => {
            return p['name'] === selection['name']
          })

          if (matches.length > 0) {
            matches[0]['children'] = content;
            setPaths(newPaths);
          }
        })
        .catch((err: any) => {
          setOpenSnack(true);
        });
    }

    const newSelections = [...path];
    newSelections.push(selection['name']);
    setSelections(newSelections);

    const selectedItem = {
      path: path,
      name: selection['name'],
      is_directory: selection['is_directory'],
      children: selection['children']
    }
    props.setSelectedItem(selectedItem);
  }

  /**
   * @param pwd The current path location
   * @param path The path to render
   * @param isDir Weather that item is a directory or not
   * @param childrens If this item is a directory, it's childs.
   */
  const renderItem = (
    currentPath: string[],
    children: any[],
    selection: string
  ) => (
    <Box key={currentPath.length > 0 ? currentPath.join('/') : 'root'}
      sx={{
        minWidth: '20%',
        border: '1px solid #eeeeee',
        padding: '10px',
        overflow: 'scroll',
        ariaLive: 'polite'
      }} >
      {
        children.map((child: any) => (
          ( child['is_directory']) 
          ?
          <ListItem
            tabIndex={0}
            key={currentPath.join('/') + '/' + child['name']}
            dense={true}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleSelection(currentPath, child)              }
            }}
            onClick={() => handleSelection(currentPath, child)}
            sx={{
              borderRadius: '5px',
              padding: '1px',
              backgroundColor: child['name'] === selection ? '#bbdefb' : '',
              "&:hover": { cursor: 'pointer' }
            }}
          >
            <Folder color='primary' /> 
            <Typography variant="subtitle1" sx={{marginLeft: '5px'}}>
              {child['name']}
            </Typography>
          </ListItem>
          :
          <ListItem
            key={child['name']}
            dense={true}
            onClick={() => handleSelection(currentPath, child)}
            sx={{
                borderRadius: '5px',
                padding: '1px',
                backgroundColor: child['name'] === selection ? '#bbdefb' : '',
                "&:hover": {cursor: 'pointer'}
              }}
          >
              <TextSnippet sx={{ color: '#9e9e9e'}}/> 
              <Typography variant="subtitle1" sx={{ marginLeft: '5px' }}>
                {child['name']}
              </Typography>
          </ListItem>
        ))
      }
    </Box>
  );

  const getPaths = (index: number) => {
    const paths = selections.slice(0, index);
    return paths;
  }

  const getChildren = (index: number) => {
    let current: any[] = paths;

    for (let i=0; i<index; i++) {
      const selection = selections[i];
      for (let child of current) {
        if (child['is_directory']) {
          if (child['name'] === selection) {
            current = child['children'];
            break;
          }
        } else if (child['name'] === selection) {
          return null;
        }
      }
    }

    return current;
  }

  const boxes: any[] = [];
  let index = 0;
  while (true) {
    const selection = (selections.length > index) ? selections[index] : '';
    const children = getChildren(index);

    if (children) {
      const box = renderItem(getPaths(index), children, selection)
      boxes.push(box);
      index++;
    }

    if (!selection)
      break;
  }

  return (
    <Stack direction={'row'} sx={{ height: '100%'}} >
      {boxes}

      <Snackbar
        role = "alert"
        aria-label = {"Alert message"}
        open={openSnack}
        autoHideDuration={6000}
        onClose={e => setOpenSnack(false)}
      >
        <Alert severity="error">
          Could not retrieve directory from server!
        </Alert>
      </Snackbar>
      
    </Stack>
  );
}
